module.exports = __webpack_public_path__ + "img/img_level_3.8ee51cbc.png";